import { SvgIconProps } from '@euler/app/components/icons/types';
import { useSvgProps } from '@euler/app/components/icons/util';
import { FC, memo } from 'react';
import { Path, Svg } from 'react-native-svg';

// Filled message bubble matching the visual weight of the other
// sidebar SVG icons (Tasks/Records/Plans/Profile).
export const MessageIconFill: FC<SvgIconProps> = memo(props => {
  const { fill = '#000', ...svgProps } = useSvgProps(props, 21, 21);
  return (
    <Svg viewBox="0 0 1024 1024" fill="none" {...svgProps}>
      <Path
        d="M192 128h640a128 128 0 0 1 128 128v448a128 128 0 0 1-128 128H400l-176 144a32 32 0 0 1-52-24.8V832h-44a128 128 0 0 1-128-128V256a128 128 0 0 1 128-128z m120 320a48 48 0 1 0 0 96 48 48 0 0 0 0-96z m200 0a48 48 0 1 0 0 96 48 48 0 0 0 0-96z m200 0a48 48 0 1 0 0 96 48 48 0 0 0 0-96z"
        fill={fill}
      />
    </Svg>
  );
});

export const MessageIcon: FC<SvgIconProps> = memo(props => {
  const { fill = '#000', ...svgProps } = useSvgProps(props, 21, 21);
  return (
    <Svg viewBox="0 0 1024 1024" fill="none" {...svgProps}>
      <Path
        d="M832 64H192A128 128 0 0 0 64 192v512a128 128 0 0 0 128 128h44v120a32 32 0 0 0 52 24.8L460 832h372a128 128 0 0 0 128-128V192a128 128 0 0 0-128-128z m64 640a64 64 0 0 1-64 64H448l-12 5.2L300 880V800a32 32 0 0 0-32-32H192a64 64 0 0 1-64-64V192a64 64 0 0 1 64-64h640a64 64 0 0 1 64 64v512z"
        fill={fill}
      />
      <Path d="M312 416m-48 0a48 48 0 1 0 96 0 48 48 0 1 0-96 0Z" fill={fill} />
      <Path d="M512 416m-48 0a48 48 0 1 0 96 0 48 48 0 1 0-96 0Z" fill={fill} />
      <Path d="M712 416m-48 0a48 48 0 1 0 96 0 48 48 0 1 0-96 0Z" fill={fill} />
    </Svg>
  );
});
